// Artikel-beoordeling — gedeelde DTOs + Zod (batch-10 #25).
//
// Medewerkers beoordelen uitgereikte spullen/materialen op productniveau
// (VoorraadArtikel). Score 1-5 (Int), optionele opmerking. Aggregatie per
// artikel. Eén bron van waarheid: dit schema valideert in de API én in het
// portal-form.

import { z } from 'zod'

export const CreateBeoordelingSchema = z.object({
  score: z.number().int().min(1, 'Geef minimaal 1 ster').max(5, 'Maximaal 5 sterren'),
  comment: z.string().trim().max(1000, 'Houd de opmerking onder de 1000 tekens').optional(),
})
export type CreateBeoordelingInput = z.infer<typeof CreateBeoordelingSchema>

/** Eén beoordeling (backoffice-view; portal krijgt geen namen). */
export interface ArtikelBeoordelingDTO {
  id: string
  score: number
  comment: string | null
  employeeNaam: string | null
  createdAt: string
}

/**
 * Aggregatie per artikel. `verdeling` is een array van lengte 5: index 0..4 =
 * aantal beoordelingen met score 1..5. `eigenScore` = de score van de
 * opvragende medewerker (null als hij nog niet beoordeelde of geen employee is).
 * `beoordelingen` is alleen gevuld voor VOORRAAD-viewers (backoffice).
 */
export interface ArtikelBeoordelingAggregatieDTO {
  artikelId: string
  gemiddelde: number | null
  aantal: number
  verdeling: number[]
  eigenScore: number | null
  beoordelingen: ArtikelBeoordelingDTO[]
}

// ─── Batch-11 P2 — exemplaarniveau (unieke uitgereikte items) ────────────────
//
// Zelfde shape als de productniveau-aggregatie, maar per concreet uitgereikt
// `UitrustingItem` i.p.v. per `VoorraadArtikel`. Hergebruikt `CreateBeoordeling
// Schema` (score 1-5 + opmerking). Aangezien een exemplaar normaliter aan één
// medewerker is uitgereikt, is `aantal` meestal 0 of 1, maar de aggregatie-vorm
// blijft gelijk zodat backoffice dezelfde rendering kan gebruiken.
export interface UitrustingItemBeoordelingAggregatieDTO {
  uitrustingItemId: string
  gemiddelde: number | null
  aantal: number
  verdeling: number[]
  eigenScore: number | null
  beoordelingen: ArtikelBeoordelingDTO[]
}
